import Helper from "../extensions/helpers/helpers";
import SettingsService from "../extensions/services/settings-service";

const languageFiles = [
    "animations",
    "calculator",
    "main",
    "settings",
];

const locales = [
    'bg', 'bn', 'cs', 'da', 'de', 'el', 'es', 'fr', 'hi', 'hr', 'id', 'it',
    'ja', 'ko', 'ms', 'nl', 'no', 'pl', 'pt', 'ro', 'ru', 'sk', 'sl', 'th',
    'tr', 'uk', 'vi', 'zh',
];

const COUNTRY_CODES = SettingsService.getLanguages().map(({value}) => value);

export const languageList = COUNTRY_CODES.map((code) => `${code}`);

/**
 *
 * @param {string} locale
 * @param {import('vue-i18n').IVueI18n} i18n
 * @return {void}
 */
export const importLanguage = (locale, i18n) => {
    try {
        const message = require(`../locale/${locale}.json`);

        i18n.mergeLocaleMessage(locale, message);
    } catch (error) {
        captureException(error);
    }
};
